import React, { Component } from "react";
import SectionFooter from "./sectionfooter";

class Videogallery extends Component {
  render() {
    return (
      <section id="videos">
        <h1>Video</h1>
        <ul className="folio-list clearfix">
          <li className="folio-thumb center">
            <h3 className="entry-title">Festumzug vom 20. Juli 2012</h3>
            <div className="thumb">
              <iframe
                className="lightbox-video"
                frameBorder="0"
                scrolling="no"
                marginHeight="0"
                marginWidth="0"
                width="788.54"
                height="443"
                title="lassmichdochinruhelinter"
                type="text/html"
                src="https://www.youtube.com/embed/PpbE1LuiYPA?autoplay=0&fs=1&iv_load_policy=3&showinfo=0&rel=0&cc_load_policy=0&start=0&end=0"
              />
            </div>
          </li>
        </ul>
        <SectionFooter />
      </section>
    );
  }
}

export default Videogallery;



// WEBPACK FOOTER //
// ./src/components/videogallery.js